export default __webpack_public_path__ + "static/media/logo.be0ce55b.png";